import PropTypes from 'prop-types'
import ActiveRecord from 'model/activeRecord'
import { isNil } from 'ramda'

class CarePod extends ActiveRecord {
  constructor(init) {
    super(init)
    // console.log('> CarePod constructor -', init)
    if (isNil(init)) return undefined
    this._name = init.name
  }

  static shape = {
    id: PropTypes.string.isRequired,
    name: PropTypes.string
  }

  get name() {
    return this._name
  }
}

export default CarePod
